import React, { useState, useEffect } from "react";
import { NavLink, Outlet, Link } from "react-router-dom";
import {
  FaUsers,
  FaCreditCard,
  FaImage,
  FaChartBar,
  FaReceipt,
  FaCog,
  FaSignOutAlt,
  FaBars,
  FaTimes,
  FaKeycdn,
  FaUsersSlash,
  FaQuestionCircle,
  FaBrain,
  FaMusic,
  FaBell,
  FaUserShield,
  FaUbuntu,
  FaCalendarAlt,
  FaHistory,
  FaPaperPlane,
} from "react-icons/fa";
import logo from "../assets/tribe25_logo.png";
import Tooltip from "../components/Tooltip.jsx";


const menuItems = [
  { name: "Dashboard", path: "/admin/dashboard", icon: FaUsers ,permission:["admin","manager","editor"]},
  { name: "Users", path: "/admin/users", icon: FaUsers, permission:["admin","manager","editor"] },
  { name: "Events", path: "/admin/events", icon: FaCalendarAlt, permission:["admin","manager","editor"] },
  { name: "Media", path: "/admin/media", icon: FaImage , permission:["admin","manager","editor"]},
  { name: "Personalities", path: "/admin/personalities", icon: FaBrain , permission:["admin","manager","editor"]},
  { name: "PlayList", path: "/admin/playlist", icon: FaMusic, permission:["admin","manager","editor"] },
  { name: "Transactions", path: "/admin/transactions", icon: FaReceipt, permission:["admin","manager"] },
  { name: "Analytics", path: "/admin/analytics", icon: FaChartBar, permission:["admin","manager"] },
  { name: "Reports", path: "/admin/reports", icon: FaUsersSlash, permission:["admin","manager"] },
  { name: "Notifications", path: "/admin/notifications", icon: FaPaperPlane, permission:["admin","manager"] },
  { name: "Audit Logs", path: "/admin/audit-logs", icon: FaHistory, permission:["admin"] },
  { name: "Admin Managers", path: "/admin/managers", icon: FaUserShield, permission:["admin"] },
  { name: "System Info", path: "/admin/system", icon: FaUbuntu, permission:["admin","manager"]  },
  { name: "Settings", path: "/admin/settings", icon: FaCog, permission:["admin","manager"] },
];

const SidebarLayout = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [role, setRole] = useState(null);

     useEffect(() => {
        // Retrieve the role from localStorage when the component mounts
        const storedRole = localStorage.getItem("role");
        if (storedRole) {
            setRole(storedRole);
        }
    }, []);

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Sidebar (desktop + mobile toggle) */}
      <aside
        className={`fixed md:static top-0 left-0 h-full w-64 bg-white shadow-lg flex flex-col z-40 transform transition-transform duration-300 
          ${isOpen ? "translate-x-0" : "-translate-x-full md:translate-x-0"}`}
      >
        {/* Header */}
        <div className="flex items-center gap-2 p-4 border-b">
          <img src={logo} alt="Logo" className="w-10 h-10 rounded-full" />
          <h2 className="text-lg font-bold text-[#db8654]">Tribe25 Admins</h2>
        </div>

        {/* Menu */}
        <nav className="flex-1 p-4 space-y-1 overflow-y-auto min-h-0 custom-scrollbar">
          {menuItems.map((item) => {
            const Icon = item.icon;
            if(item.permission.indexOf(role) <= -1) return;
            return (
              <NavLink
                key={item.name}
                to={item.path}
                onClick={() => setIsOpen(false)} // close on mobile click
                className={({ isActive }) =>
                  `flex items-center gap-2 px-3 py-2 rounded-lg font-medium transition-colors ${
                    isActive
                      ? "bg-[#db8654] text-white"
                      : "text-gray-700 hover:bg-gray-100"
                  }`
                }
              >
                <Icon size={18} />
                {item.name}
              </NavLink>
            );
          })}
        </nav>


        {/* Footer */}
        <div className="p-4 border-t flex items-center justify-between text-sm text-gray-600">
        {/* Admin Info with Link */}
        <Link
          to="/admin/profile"
          className="flex items-center gap-2 hover:text-[#db8654] transition"
        >
          <img
            src={
              localStorage.getItem("profilePic") ||
              "https://ui-avatars.com/api/?name=" +
                localStorage.getItem("firstName") +
                "+" +
                localStorage.getItem("lastName")
            }
            alt="Admin Avatar"
            className="w-9 h-9 rounded-full object-cover"
          />
          <span className="font-medium flex flex-col leading-tight">
            <span>
              {localStorage.getItem("firstName")} {localStorage.getItem("lastName")}
            </span>
            <span className="text-xs text-gray-500">
              {localStorage.getItem("role") || "Admin"}
            </span>
          </span>
        </Link>


        {/* Logout Button */}
        <Tooltip text="Logout">

        <button
            onClick={() => {
            localStorage.clear();
            window.location.href = "/signin";
            }}
            className="flex items-center gap-1 text-red-500 hover:text-red-600 font-medium"
        >
            <FaSignOutAlt size={16} />
            
        </button>
        </Tooltip>
        </div>

      </aside>

      {/* Overlay for mobile */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-30 md:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Main Content */}
      <div className="flex-1 flex flex-col">
        {/* Header (with hamburger on mobile) */}
        <header className="bg-white shadow-md p-4 flex items-center justify-between md:hidden">
          <button
            className="text-gray-700"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <FaTimes size={22} /> : <FaBars size={22} />}
          </button>
          <h2 className="text-lg font-bold text-[#db8654]">Admin Dashboard</h2>
        </header>

        <main className="flex-1 overflow-y-auto p-4 md:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default SidebarLayout;
